import { FormattedMessage } from 'react-intl';

export const getErrorMessage = (key: string, value: string) =>
  ({
    'payment.form.validation.required': (
      <FormattedMessage
        id="payment.form.validation.required"
        defaultMessage="This field is required"
        description="Validation message for required field"
      />
    ),
    'payment.form.validation.invalid.chars': (
      <FormattedMessage
        id="payment.form.validation.invalid.chars"
        defaultMessage="Please ensure that the name contains only alphabets.{br}Invalid characters: {chars}"
        description="Validation message when user enters invalid characters in the name field"
        values={{
          br: <br />,
          chars: [...new Set(value.split(''))]
            .filter((char) => !/^(\p{Letter}| )+$/u.test(char))
            .join(' '),
        }}
      />
    ),
  })[key];
